var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import LocationSearchProviderTraits, { SearchProviderMapCenterTraits } from "./LocationSearchProviderTraits";
let BingMapsSearchProviderTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Key",
  description: "The Bing Maps key."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Primary country",
  description: "Name of the country to prioritize the search results."
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Culture",
  description: "Use the culture parameter to specify a culture for your request.\n    The culture parameter provides the result in the language of the culture.\n    For a list of supported cultures, see [Supported Culture Codes](https://docs.microsoft.com/en-us/bingmaps/rest-services/common-parameters-and-types/supported-culture-codes)"
}), _dec4 = primitiveTrait({
  type: "number",
  name: "Max results",
  description: "The maximum number of results to return."
}), _class = class BingMapsSearchProviderTraits extends mixTraits(LocationSearchProviderTraits, SearchProviderMapCenterTraits) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "url", "https://dev.virtualearth.net/");
    _initializerDefineProperty(this, "key", _descriptor, this);
    _initializerDefineProperty(this, "primaryCountry", _descriptor2, this);
    _initializerDefineProperty(this, "culture", _descriptor3, this);
    _initializerDefineProperty(this, "maxResults", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "key", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "primaryCountry", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "Australia";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "culture", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "en-au";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "maxResults", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 5;
  }
}), _class);
export { BingMapsSearchProviderTraits as default };